module.exports = __webpack_public_path__ + "assets/img/copy.8366b7c6.png";